export default __webpack_public_path__ + "static/business-startup-093e9f08f33ef11ec28db3cf5f753605.png";